import router from '@reduck/plugin-router';

/* eslint-disable @typescript-eslint/no-namespace */
/* eslint-enable @typescript-eslint/no-namespace */

export default router;
//# sourceMappingURL=router.browser.esm.js.map
